// @flow

import { combineReducers } from 'redux';
import type { CombinedReducer } from 'redux';

import type { RootActions } from '../types';

import { commonReducer } from './commonReducer';
import { contentReducer } from './contentReducer';
import { depositReducer } from './depositReducer';
import { franceConnect } from './franceConnect';
import { i18nReducer } from './i18nReducer';
import { landingReducer } from './landingReducer';
import { paypalConnect } from './paypalConnect';
import { sessionReducer } from './sessionReducer';
import { tagManagerReducer } from './tagManagerReducer';
import { userRegistrationReducer } from './userRegistrationReducer';
import { websocketReducer } from './websocketReducer';

const combinedReducers = {
  websocket: websocketReducer,
  content: contentReducer,
  i18n: i18nReducer,
  common: commonReducer,
  userRegistration: userRegistrationReducer,
  deposit: depositReducer,
  franceConnect,
  session: sessionReducer,
  landing: landingReducer,
  tagManager: tagManagerReducer,
  paypalConnect,
};

export const reducers: CombinedReducer<typeof combinedReducers, RootActions> = combineReducers(
  combinedReducers,
);
